import { render } from "./InputUrl.vue?vue&type=template&id=6572c83a&ts=true"
import script from "./InputUrl.vue?vue&type=script&lang=ts"
export * from "./InputUrl.vue?vue&type=script&lang=ts"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__